import { render, staticRenderFns } from "./CopyStakeSettingsShowOnlyStreamers.vue?vue&type=template&id=24cc512e&lang=pug"
import script from "./CopyStakeSettingsShowOnlyStreamers.vue?vue&type=script&lang=ts"
export * from "./CopyStakeSettingsShowOnlyStreamers.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeSettingsShowOnlyStreamers.vue?vue&type=style&index=0&id=24cc512e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow,VSwitch})
